import React from 'react';
import { Button, Flex } from 'antd';
import styles from './DiscardConfirmPrompt.module.css';

interface DiscardConfirmPromptProps {
  onKeepEditing: () => void;
  onDiscard: () => void;
}

/** "Discard unsaved changes?" overlay with Keep editing / Discard, shown by
 * the list-edit panel when it's left with unsaved edits. */
const DiscardConfirmPrompt: React.FC<DiscardConfirmPromptProps> = ({
  onKeepEditing,
  onDiscard,
}) => {
  return (
    <div className={styles.prompt}>
      <span className={styles.message}>Discard unsaved changes?</span>
      <Flex gap={8} justify='flex-end'>
        <Button onClick={onKeepEditing}>Keep editing</Button>
        <Button danger type='primary' onClick={onDiscard}>
          Discard
        </Button>
      </Flex>
    </div>
  );
};

export default DiscardConfirmPrompt;
